(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-variant-metafield"] && !Shopify.designMode) return;
  try {
    class VariantMetafieldDisplay extends HTMLElement {
    constructor() {
      super();
      this.valueElement = this.querySelector('[data-value]');
      this.metafieldMap = {};
      this.fallback = this.dataset.fallback || '';
      
      this.parseMetafieldData();
      this.bindEvents();
    }
    
    parseMetafieldData() {
      const jsonScript = this.querySelector('[data-metafield-map]');
      if (jsonScript) {
        try {
          this.metafieldMap = JSON.parse(jsonScript.textContent);
        } catch (e) {
          console.error('VariantMetafieldDisplay: Failed to parse metafield data', e);
        }
      }
    }
    
    bindEvents() {
      document.addEventListener('variant:change', this.handleVariantChange.bind(this));
      window.addEventListener('popstate', this.handleUrlChange.bind(this));
      this.handleUrlChange();
      this.interceptHistoryMethods();
    }
    
    interceptHistoryMethods() {
      const self = this;
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;
      
      history.pushState = function(...args) {
        originalPushState.apply(this, args);
        self.handleUrlChange();
      };
      
      history.replaceState = function(...args) {
        originalReplaceState.apply(this, args);
        self.handleUrlChange();
      };
    }
    
    handleVariantChange(event) {
      const variant = event?.detail?.variant;
      if (variant?.id) {
        this.updateDisplay(variant.id);
      }
    }
    
    handleUrlChange() {
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get('variant');
      if (variantId) {
        this.updateDisplay(variantId);
      }
    }
    
    updateDisplay(variantId) {
      if (!this.valueElement) return;
      
      const value = this.metafieldMap[variantId];
      const hasValue = value !== null && value !== undefined && value !== '';
      
      if (hasValue) {
        this.valueElement.innerHTML = value;
        this.setAttribute('data-has-value', '');
      } else {
        this.valueElement.textContent = this.fallback;
        if (this.fallback) {
          this.setAttribute('data-has-value', '');
        } else {
          this.removeAttribute('data-has-value');
        }
      }
    }
    
    disconnectedCallback() {
      document.removeEventListener('variant:change', this.handleVariantChange);
      window.removeEventListener('popstate', this.handleUrlChange);
    }
  }
  
  if (!customElements.get('variant-metafield-display')) {
    customElements.define('variant-metafield-display', VariantMetafieldDisplay);
  }
  } catch(e) { console.error(e); }
})();

})();
